// ============================================================
// 本地 Mock 数据层（开发联调用）
// 开关：.env 中 VUE_APP_MOCK=true 时启用；后端就绪后设为 false 走真实接口
// 所有 mock 响应统一为服务端约定结构：{ code: 200, msg, data }
// ============================================================

const delay = (ms) => new Promise((r) => setTimeout(r, ms))

const MOCK_USER = {
  id: 1,
  nickname: '小狐狸用户',
  avatarUrl: 'https://arya-asset.oss-cn-shanghai.aliyuncs.com/echo/common/logo4.png',
  channel: 2009
}

const SCENES = ['解说', '推文', '广告', '教育', '情感', '故事', '新闻', '儿童', '游戏', '电商']

// 预设音色（coverColor 为渐变底色，前端无封面图时用首字 + 底色渲染）
const presetVoices = [
  { id: 1, name: '阳光男声', desc: '清爽自然的男声，适合日常解说与生活类内容', scenes: '解说,推文', duration: 8, previewText: '用一段好声音，讲述一个好故事。', coverColor: '#F08238' },
  { id: 2, name: '温柔女声', desc: '温暖治愈的女声，适合情感电台与慢节奏内容', scenes: '情感,推文', duration: 9, previewText: '慢慢来，一切都来得及。', coverColor: '#E88A8A' },
  { id: 3, name: '元气少女', desc: '活泼元气的少女音，适合动漫与轻松内容', scenes: '儿童,游戏,动漫', duration: 7, previewText: '今天也要元气满满哦！', coverColor: '#F2A65A' },
  { id: 4, name: '磁性大叔', desc: '低沉磁性的男声，适合故事与纪录类内容', scenes: '故事,解说,新闻', duration: 10, previewText: '在那遥远的地方，有一个古老的故事。', coverColor: '#7A6A5F' },
  { id: 5, name: '清朗少年', desc: '清澈的少年音，适合教育科普类内容', scenes: '教育,动漫', duration: 8, previewText: '知识改变命运，学习成就未来。', coverColor: '#5BA8E8' },
  { id: 6, name: '甜美主播', desc: '甜美亲切的女声，适合电商直播与广告', scenes: '电商,广告', duration: 7, previewText: '全网最低价，就是现在！', coverColor: '#E86AA8' },
  { id: 7, name: '沉稳旁白', desc: '沉稳大气的旁白音，适合纪录片与专题', scenes: '新闻,解说,纪录片', duration: 9, previewText: '这是一片充满希望的土地。', coverColor: '#4E5D6E' },
  { id: 8, name: '活力快嘴', desc: '语速明快的男声，适合游戏解说与促销', scenes: '广告,游戏', duration: 6, previewText: '开局一把枪，装备全靠捡！', coverColor: '#E8503C' },
  { id: 9, name: '知性姐姐', desc: '知性优雅的女声，适合知识分享与职场', scenes: '教育,推文', duration: 9, previewText: '真正的成长，是学会与时间做朋友。', coverColor: '#7A8A5F' },
  { id: 10, name: '温暖爷爷', desc: '慈祥温暖的老者音，适合亲情与怀旧内容', scenes: '故事,情感', duration: 10, previewText: '孩子，记住家的方向，就是记住来时的路。', coverColor: '#B08A5A' },
  { id: 11, name: '俏皮精灵', desc: '古灵精怪的童声，适合趣味与少儿内容', scenes: '儿童,动漫', duration: 6, previewText: '嘿，猜猜我今天发现了什么？', coverColor: '#8AA8E8' },
  { id: 12, name: '商务精英', desc: '专业干练的男声，适合商业与品牌内容', scenes: '广告,解说,教育', duration: 8, previewText: '选择我们，就是选择专业与信赖。', coverColor: '#3E6E9E' },
  { id: 13, name: '深夜电台', desc: '低柔舒缓的女声，适合睡前陪伴与情感内容', scenes: '情感,故事,电台', duration: 11, previewText: '夜深了，把心事讲给星星听。', coverColor: '#8A6AB0' },
  { id: 14, name: '热血少年', desc: '充满激情的男声，适合体育与燃系内容', scenes: '游戏,动漫,解说', duration: 7, previewText: '只要不放弃，就还没有输！', coverColor: '#E8703C' },
  { id: 15, name: '治愈男声', desc: '柔和治愈的男声，适合冥想与生活记录', scenes: '情感,教育,电台', duration: 9, previewText: '放慢脚步，感受生活的小确幸。', coverColor: '#5FA88A' }
]

// 用户录制/上传的音色（mock 演示数据）
const selfVoices = [
  { id: 101, name: '我的声音', desc: '我录制的声音', scenes: '自定义', duration: 12, coverColor: '#D9A86A', source: 'record' }
]

// 历史作品（mock 演示数据）
let workSeq = 5000
const now = Date.now()
const works = [
  {
    echoDubbingVo: {
      id: 5001, voiceId: 2, status: 1, content: '慢慢来，一切都来得及。把日子过成自己想要的样子，就是我们最好的生活。',
      language: 'ZH', emotion: '温柔', speed: 1, duration: 18, createTime: new Date(now - 2 * 86400000).toISOString(),
      audioUrl: '', errorMsg: ''
    },
    voiceVo: { id: 2, name: '温柔女声', description: '温暖治愈的女声', coverColor: '#E88A8A', scenes: '情感,推文' }
  },
  {
    echoDubbingVo: {
      id: 5002, voiceId: 1, status: 1, content: '用一段好声音，讲述一个好故事。每天五分钟，带你听见不一样的世界。',
      language: 'ZH', emotion: '平静', speed: 1, duration: 26, createTime: new Date(now - 1 * 86400000).toISOString(),
      audioUrl: '', errorMsg: ''
    },
    voiceVo: { id: 1, name: '阳光男声', description: '清爽自然的男声', coverColor: '#F08238', scenes: '解说,推文' }
  },
  {
    echoDubbingVo: {
      id: 5003, voiceId: 0, status: 2, content: '这是一段合成失败的作品，用于演示失败状态展示。',
      language: 'ZH', emotion: '严肃', speed: 1.5, duration: 0, createTime: new Date(now - 3 * 86400000).toISOString(),
      audioUrl: '', errorMsg: '合成服务暂时不可用'
    },
    voiceVo: { id: 0, name: '自定义音色', description: '我录制的声音', coverColor: '#D9A86A', scenes: '自定义' }
  },
  {
    echoDubbingVo: {
      id: 5004, voiceId: 6, status: 1, content: "English is a global language. Let's practice together every day!",
      language: 'EN', emotion: '开心', speed: 1.25, duration: 15, createTime: new Date(now - 5 * 86400000).toISOString(),
      audioUrl: '', errorMsg: ''
    },
    voiceVo: { id: 6, name: '甜美主播', description: '甜美亲切的女声', coverColor: '#E86AA8', scenes: '电商,广告' }
  },
  {
    echoDubbingVo: {
      id: 5005, voiceId: 9, status: 1, content: '真正的成长，是学会与时间做朋友。把每一分钟都用在值得的事情上。',
      language: 'ZH', emotion: '知性', speed: 0.75, duration: 22, createTime: new Date(now - 6 * 86400000).toISOString(),
      audioUrl: '', errorMsg: ''
    },
    voiceVo: { id: 9, name: '知性姐姐', description: '知性优雅的女声', coverColor: '#7A8A5F', scenes: '教育,推文' }
  },
  {
    echoDubbingVo: {
      id: 5006, voiceId: 3, status: 1, content: '今天也要元气满满哦！和 AI配音小狐狸一起，让每一段文字都活起来。',
      language: 'ZH', emotion: '开心', speed: 1, duration: 12, createTime: new Date(now - 8 * 86400000).toISOString(),
      audioUrl: '', errorMsg: ''
    },
    voiceVo: { id: 3, name: '元气少女', description: '活泼元气的少女音', coverColor: '#F2A65A', scenes: '儿童,游戏,动漫' }
  }
]

// ============ 扫码登录会话（mock） ============
const sessions = {}

// ============ 各接口 mock 处理 ============
async function handle(options) {
  const { url = '', method = 'GET', data = {} } = options
  await delay(260)

  const path = url.split('?')[0]

  // ---- 登录 ----
  if (path === '/echo/auth/pc/qr') {
    const sessionId = 'mock-session-' + Math.random().toString(36).slice(2, 10)
    sessions[sessionId] = { scanned: false }
    return ok({
      sessionId,
      // 真实后端返回「小程序码图片地址」或「scheme 内容」任选其一：
      qrContent: 'weixin://dl/business/?t=' + sessionId
    })
  }

  if (path === '/echo/auth/pc/status') {
    const sid = url.split('?')[1] && new URLSearchParams(url.split('?')[1]).get('sessionId')
    const s = sessions[sid]
    if (s && s.scanned) return ok({ status: 'success', token: 'Bearer mock-token-abc123', user: { ...MOCK_USER } })
    return ok({ status: 'pending' })
  }

  // ---- 用户 ----
  if (path === '/echo/user/info') return ok({ ...MOCK_USER })
  if (path === '/echo/user/update') {
    Object.assign(MOCK_USER, { nickname: data.nickname, avatarUrl: data.avatarBase64 || MOCK_USER.avatarUrl })
    return ok({ ...MOCK_USER })
  }

  // ---- 音色 ----
  if (path === '/echo/voice/all') {
    return ok({ selfVoices: selfVoices.map(decorateVoice), scenes: SCENES })
  }
  if (path === '/echo/voice/search') {
    const keyword = (data.keyword || '').trim().toLowerCase()
    const sceneList = data.sceneList || []
    let list = presetVoices.filter((v) => {
      const kwOk = !keyword || v.name.toLowerCase().includes(keyword) || (v.desc || '').toLowerCase().includes(keyword)
      const sceneOk = !sceneList.length || sceneList.some((s) => v.scenes.includes(s))
      return kwOk && sceneOk
    })
    const pageNum = data.pageNum || 1
    const size = 10
    const start = (pageNum - 1) * size
    const content = list.slice(start, start + size)
    return ok({ content: content.map(decorateVoice), totalElements: list.length })
  }

  // ---- 配音 ----
  if (path === '/echo/dubbing/start') {
    const taskId = ++workSeq
    const form = data // 已是文本字段
    const voiceId = data.voiceId || 0
    const voice = presetVoices.find((v) => v.id === voiceId)
    works.unshift({
      echoDubbingVo: {
        id: taskId,
        voiceId,
        status: 0,
        content: form.text || '',
        language: form.language || 'ZH',
        emotion: form.emotion || '跟随原声',
        speed: Number(form.speed) || 1,
        duration: 0,
        createTime: new Date().toISOString(),
        audioUrl: '',
        errorMsg: ''
      },
      voiceVo: voice
        ? { id: voice.id, name: voice.name, description: voice.desc, coverColor: voice.coverColor, scenes: voice.scenes }
        : { id: 0, name: form.name || '自定义音色', description: '我录制或上传的声音', coverColor: '#D9A86A', scenes: '自定义' }
    })
    return ok(taskId)
  }

  if (path === '/echo/dubbing/detail') {
    const id = Number(new URLSearchParams(url.split('?')[1]).get('id'))
    const item = works.find((w) => w.echoDubbingVo.id === id)
    if (!item) return ok(null)
    const d = item.echoDubbingVo
    // 模拟合成完成：创建 3 秒后状态置为已完成
    if (d.status === 0 && Date.now() - new Date(d.createTime).getTime() > 3000) {
      d.status = 1
      d.duration = Math.max(8, Math.min(120, Math.round(d.content.length / 6)))
      d.audioUrl = ''
    }
    return ok({
      echoDubbingVo: { ...d },
      voiceVo: { ...item.voiceVo }
    })
  }

  if (path === '/echo/dubbing/history') {
    const sort = data.sort || 'desc'
    const keyword = (data.keyword || '').trim().toLowerCase()
    const language = data.language || ''
    const emotion = (data.emotion || '').trim().toLowerCase()
    let list = works.filter((w) => {
      const d = w.echoDubbingVo
      if (keyword && !(d.content || '').toLowerCase().includes(keyword)) return false
      if (language && d.language !== language) return false
      if (emotion && !(d.emotion || '').toLowerCase().includes(emotion)) return false
      return true
    })
    list = list.slice().sort((a, b) => {
      const ta = new Date(a.echoDubbingVo.createTime).getTime()
      const tb = new Date(b.echoDubbingVo.createTime).getTime()
      return sort === 'asc' ? ta - tb : tb - ta
    })
    const pageNum = data.pageNum || 1
    const size = 10
    const start = (pageNum - 1) * size
    return ok({ content: list.slice(start, start + size), totalElements: list.length })
  }

  if (path.startsWith('/echo/dubbing/') && method === 'DELETE') {
    const id = Number(path.split('/').pop())
    const idx = works.findIndex((w) => w.echoDubbingVo.id === id)
    if (idx !== -1) works.splice(idx, 1)
    return ok(true)
  }

  // 未匹配：模拟一个"无此接口"的失败
  return { code: 404, msg: `Mock 未实现接口：${method} ${url}`, data: null }
}

function ok(data) {
  return { code: 200, msg: 'success', data }
}

function decorateVoice(v) {
  return {
    id: v.id,
    name: v.name,
    desc: v.desc,
    description: v.desc,
    coverUrl: v.coverUrl || '',
    coverColor: v.coverColor || '',
    audioUrl: v.audioUrl || '',
    previewText: v.previewText || '',
    scenes: String(v.scenes || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean),
    duration: v.duration || 0,
    source: v.source || 'preset'
  }
}

/** 模拟"用户已扫码授权"（登录页 mock 用） */
export function mockLogin(sessionId) {
  if (sessions[sessionId]) sessions[sessionId].scanned = true
}

export default { request: handle }
